module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1500.96da7842.svg";